import { EULA_SECTIONS, type EulaBlock } from './eulaContent';

const HEADING_STYLES: Record<2 | 3 | 4, React.CSSProperties> = {
  2: { margin: '8px 0 2px', color: 'rgba(228,228,228,0.92)', fontSize: 13, lineHeight: '18px', fontWeight: 600 },
  3: { margin: '4px 0 2px', color: 'rgba(228,228,228,0.82)', fontSize: 12, lineHeight: '16px', fontWeight: 590 },
  4: { margin: '4px 0 2px', color: 'rgba(228,228,228,0.72)', fontSize: 11, lineHeight: '16px', fontWeight: 590 },
};

const EulaBlockRenderer = ({ block }: { block: EulaBlock }) => {
  if (block.type === 'heading') {
    return <p style={HEADING_STYLES[block.level]}>{block.text}</p>;
  }
  if (block.type === 'list') {
    return (
      <ul style={{ margin: 0, paddingLeft: 18, color: 'rgba(228,228,228,0.553)' }}>
        {block.items.map((item, j) => (
          <li key={j} style={{ fontSize: 11, lineHeight: '16px', fontWeight: 400, marginBottom: 2 }}>{item}</li>
        ))}
      </ul>
    );
  }
  return (
    <p style={{ margin: 0, color: 'rgba(228,228,228,0.553)', fontSize: 11, lineHeight: '16px', fontWeight: 400, whiteSpace: 'pre-line' }}>
      {block.text}
    </p>
  );
};

interface ProgramTermsProps {
  onBack: () => void;
}

export const ProgramTerms = ({ onBack }: ProgramTermsProps) => (
  <div
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      boxSizing: 'border-box',
      padding: '14px 0px',
    }}
  >
    <button
      type="button"
      onClick={onBack}
      style={{
        border: 'none',
        background: 'transparent',
        padding: 0,
        marginBottom: 12,
        cursor: 'pointer',
        textAlign: 'left',
        alignSelf: 'flex-start',
      }}
    >
      <p style={{ margin: 0, color: 'rgba(228,228,228,0.553)', fontSize: 12, lineHeight: '16px', fontWeight: 590 }}>
        ← Settings
      </p>
    </button>

    <p style={{ margin: '0 0 12px', color: 'rgba(228,228,228,0.92)', fontSize: 18, lineHeight: '20px', fontWeight: 590, textAlign: 'center' }}>
      EULA
    </p>

    <div className="hr-scroll" style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
      <div style={{ paddingInline: 6, boxSizing: 'border-box' }}>
        <div
          style={{
            padding: 12,
            borderRadius: 8,
            border: '1px solid rgba(228,228,228,0.12)',
            background: 'rgba(228,228,228,0.067)',
          }}
        >
          <p style={{ margin: '0 0 10px', color: 'rgba(228,228,228,0.37)', fontSize: 10, lineHeight: '16px', fontWeight: 400, letterSpacing: 0.5 }}>
            END USER LICENSE AGREEMENT
          </p>
          <p style={{ margin: '0 0 6px', color: 'rgba(228,228,228,0.37)', fontSize: 10, lineHeight: '14px', fontWeight: 400 }}>
            Last updated: June 11, 2025 · Version 1.0
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%' }}>
            {EULA_SECTIONS.map((block, i) => (
              <EulaBlockRenderer key={i} block={block} />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);
